import { createFileRoute } from '@tanstack/react-router'
import { Feedback } from '@thom/folio-ui/pages/feedback'

export const Route = createFileRoute('/_authenticated/$client/$domain/$slug/feedback/')({
	component: Feedback,
})
